/* eslint-disable curly */
/* eslint-disable no-multi-assign */
/* eslint-disable no-param-reassign */
/* eslint-disable consistent-this */

export function getCanvas(childKey) {
  const Canvas =
    this.getRootData('Canvas') ||
    this.lookup('Canvas') ||
    this.lookdown('Canvas')
  if (!Canvas) {
    return
  }

  if (childKey) {
    return Canvas[childKey]
  }
  return Canvas
}

export function getPlayground() {
  const Playground = this.getCanvas()?.parent
  if (!Playground) {
    return
  }
  return Playground
}

export function getVersionsAside() {
  const Playground = this.getPlayground()
  if (!Playground) {
    return
  }
  return Playground.parent?.Versions?.VersionsAside
}

export function getLocalStorageCanvasData() {
  const localStorageKey = `${this.getAppKey()?.split('.')[0]}__data`
  return this.call('getLocalStorage', localStorageKey)
}

export function getCanvasScope(childKey) {
  const canvas = this.getCanvas()
  const scope = canvas?.scope

  if (childKey) {
    return scope?.[childKey]
  }

  return scope
}

export function setCanvasScope(obj) {
  const scope = this.getCanvasScope()
  this.call('overwrite', scope, obj)
  this.syncCanvas(obj)
  return scope
}

export function getActiveCanvasPage() {
  return this.getCanvasScope('activeCanvasPage')
}

export function getCanvasFrame() {
  return this.getCanvas()?.Iframe
}

export function getCanvasFrameWindow() {
  return this.getCanvasFrame()?.node.contentWindow
}

export function getEditorPanels() {
  return this.getCanvas()?.parent.Chosen.Flex?.EditorPanels
}

export function getComponentPanelSwitcher() {
  return this.getEditorPanels()?.ComponentEditor.PanelSwitcher
}

export function getComponentCodeEditor() {
  return this.getComponentPanelSwitcher()?.content?.CodePreviewWidget.Monaco
}

export function getDocsView() {
  return this.getChosenScene()?.DocsView
}

export function getDynamicIsland() {
  return this.getPlayground()?.DynamicIsland
}

export function getQuickEditor() {
  return this.getPlayground()?.QuickEditor
}

export function getFloatingPanelElement() {
  return this.getPlayground()?.FloatingPanel
}

export function getCanvasModal() {
  return this.getPlayground()?.CanvasModal
}

export function getCanvasNavbar() {
  return this.getPlayground()?.MainCanvasNavbar
}

export function getFilesSidebar() {
  // return this.getDynamicIsland()?.FilesSidebar
  return this.getDynamicIsland()?.content
}

export function getFilesSidebarPrompt() {
  return this.getFilesSidebar()?.FilesSidebarPrompt
}

export function getCanvasPages() {
  if (this.isEmbed()) return this.getCanvas()?.ChooseCanvas
  return this.getCanvasNavbar()?.CanvasPagesDropdown
}

export function getComponentEditor() {
  return this.getEditorPanels().ComponentEditor
}

export function getChosenElement() {
  return this.getPlayground()?.Chosen
}

export function getChosenData(key) {
  const data = this.getChosenElement()?.data
  return key ? data[key] : data
}

export function getChosenElementContext() {
  return this.getChosenElement()?.data.chosen?.context
}

export function getChosenScene() {
  return this.getChosenElement()?.Flex?.ChosenScene
}

export function getChosenViewSvitcher() {
  return this.getChosenScene()?.ViewSvitcher
}

export function getChosenIframe() {
  return this.getChosenScene()?.ViewSvitcher?.ComponentFrameCanvas.Iframe
}

export function getChosenIframeWindow() {
  return this.getChosenIframe()?.node.contentWindow
}

export function getChosenSceneNavbar() {
  return this.getChosenElement()?.SceneNavbar
}

export function getCanvasCollection() {
  return this.getCanvasScope('Collection')
}

export function getCanvasContext() {
  return this.getCanvasCollection().context
}

export function activateHovered(val) {
  if (!this.call('isDefined', val)) {
    val = this
  }
  const data = this.getCanvasScope()
  const hovered = (data.hovered = this.call('isDefined', val) ? val : null)
  return this.syncCanvas({ hovered })
}

export function activateSelected(val, opts = {}) {
  const data = this.getCanvasScope()

  if (!this.call('isDefined', val)) {
    val = this
  } else if (this.call('isString', val)) {
    const type = this.getType(val)
    const isOnCurrent = this.call('inOnCurrentCanvasPage', type, val)
    if (!isOnCurrent) {
      const onOtherCanvasPage = this.call(
        'findKeyInOtherCanvasPages',
        type,
        val
      )
      if (onOtherCanvasPage) {
        this.call('openCanvasPage', onOtherCanvasPage)
      }
    }
    val = this.call('findComponentOnCanvas', val)
  }
  const selected = (data.selected = this.call('isDefined', val)
    ? val
    : data.hovered)
  if (selected) {
    this.changeCodePriority('component', opts)
    if (this.getUserSettings('autoSelectSidebar')) {
      if (this.call('getSidebarContent') !== 'ARTBOARD_TYPES')
        this.call('setSidebarContent', 'ARTBOARD_TYPES')
    }
  }
  this.updateSelectedLabel()
  return !opts.preventSync ? this.syncCanvas({ selected }) : data
}

export function updateSelectedLabel() {
  if (this.isEmbed()) return
  if (this.getFilesSidebar()?.FilesSidebarPrompt?.state?.focused) {
    this.getFilesSidebar().FilesSidebarPrompt.Label.SearchOverlay.SelectedResource.update()
  }
}

export function activateChosen(val, opts = {}) {
  const data = this.getCanvasScope()
  if (!this.call('isDefined', val)) {
    val = this
  } else if (this.call('isString', val)) {
    const type = this.getType(val)
    const isOnCurrent = this.call('inOnCurrentCanvasPage', type, val)
    let onOtherCanvas = null
    if (isOnCurrent) {
      onOtherCanvas = null
    } else {
      onOtherCanvas = this.call('findKeyInOtherCanvasPages', type, val)
    }
    if (onOtherCanvas) {
      this.call('openCanvasPage', onOtherCanvas)
    }
    val = data.Collection?.lookdown((el) => el.state?.key === val)
  }
  const chosen = (data.chosen = this.call('isDefined', val)
    ? val
    : data.selected)
  if (chosen && chosen.state) {
    const { key } = chosen.state
    // this.addToTabs(key)
    this.updateRecents(key)
    this.changeCodePriority('component', opts)
    if (this.call('getSidebarContent') !== 'ARTBOARD_TYPES')
      this.call('setSidebarContent', 'ARTBOARD_TYPES')
  }
  return !opts.preventSync ? this.syncCanvas({ chosen }) : data
}

export function activateContext2(ev, val) {
  if (ev?.stopPropagation) {
    ev.stopPropagation()
  }

  const data = this.getCanvasScope()

  const isString = this.call('isString', val)
  const isDefined = this.call('isDefined', val)

  const isNull = val === null
  if (!ev || isNull) {
    return this.syncCanvas({
      inContext: null,
      positions: {
        contextX: null,
        contextY: null
      }
    })
  }

  if (isString) {
    const onOtherCanvas =
      this.call('findKeyInOtherCanvasPages', val) || 'Default'
    if (onOtherCanvas) {
      this.call('openCanvasPage', onOtherCanvas)
    }
    val =
      this.getCanvasCollection().lookdown((el) => el.state?.key === val) ||
      this.getItem(val) ||
      this.getHovered()
  } else if (!isDefined) {
    val = this
  }

  const inContext = (data.inContext = val)
  const { clientX, clientY } = ev

  return this.syncCanvas({
    inContext: inContext || null,
    positions: {
      contextX: clientX || null,
      contextY: clientY || null
    }
  })
}

// export function activateContextInSidebar(ev, val) {
export function activateContext(
  ev,
  val,
  preventDefault = true,
  stopPropagation = true
) {
  if (ev?.stopPropagation && stopPropagation) {
    ev.stopPropagation()
  }
  if (ev?.preventDefault && preventDefault) {
    ev.preventDefault()
  }

  const data = this.getCanvasScope()

  const isString = this.call('isString', val)
  const isDefined = this.call('isDefined', val)

  const updateContextMenuPosition = () => {
    const ContextMenu = this.getPlayground().lookdown('ContextMenu')
    const Overflow = this.getFilesSidebar()?.Overflow
    const target = this._contextMenuTarget
    const PANEL_OFFSET = {
      TOP: 10
    }

    if (ContextMenu && target && Overflow) {
      const targetRect = target.getBoundingClientRect()
      const overflowRect = Overflow.node.getBoundingClientRect()
      const contextMenuRect = ContextMenu.node.getBoundingClientRect()
      const contextMenuHeight = contextMenuRect.height
      const rightPosition = ev.clientX
      const viewportHeight = window.innerHeight
      let topPosition = targetRect.top + targetRect.height / 2

      if (topPosition + contextMenuHeight > viewportHeight) {
        topPosition = viewportHeight - contextMenuHeight - PANEL_OFFSET.TOP
      }

      const isOutOfBounds =
        targetRect.bottom > overflowRect.bottom ||
        targetRect.top < overflowRect.top

      if (!isOutOfBounds) {
        ContextMenu.setNodeStyles({
          transform: `translate(${rightPosition}px, ${topPosition}px)`
        })
      }

      return isOutOfBounds
    }
  }

  const clearContextMenu = () => {
    window.removeEventListener('scroll', updateContextMenuPosition, true)
    window.removeEventListener('resize', updateContextMenuPosition, true)
    this._contextMenuTarget = null
    return this.syncCanvas({
      inContext: null,
      positions: {
        contextX: null,
        contextY: null
      }
    })
  }

  const isNull = val === null
  if (!ev || isNull) {
    return clearContextMenu()
  }

  if (isString) {
    const type = this.getType(val)
    const isOnCurrent = this.call('inOnCurrentCanvasPage', type, val)
    let onOtherCanvas = null
    if (!isOnCurrent) {
      onOtherCanvas = this.call('findKeyInOtherCanvasPages', val)
    }
    if (onOtherCanvas) {
      this.call('openCanvasPage', onOtherCanvas)
    }
    val =
      this.getCanvasCollection().lookdown((el) => el.state?.key === val) ||
      this.getItem(val) ||
      this.getHovered()
  } else if (!isDefined) {
    val = this
  }

  const inContext = (data.inContext = val)
  const { clientX, clientY } = ev
  this._contextMenuTarget = val && val.node ? val.node : null

  const handleScroll = () => {
    const hideContextMenu = updateContextMenuPosition()
    if (hideContextMenu) {
      clearContextMenu()
    }
  }

  const handleResize = () => {
    const hideContextMenu = updateContextMenuPosition()
    if (hideContextMenu) {
      clearContextMenu()
    }
  }

  window.addEventListener('scroll', handleScroll, true)
  window.addEventListener('resize', handleResize, true)

  requestAnimationFrame(() => {
    updateContextMenuPosition()
  })

  return this.syncCanvas({
    inContext: inContext || null,
    positions: {
      contextX: clientX || null,
      contextY: clientY || null
    }
  })
}

export function changeCodePriority(val, opts = {}) {
  if (!this.call('isDefined', val)) {
    val = this
  }
  const data = this.getCanvasScope()
  const priorityCode = (data.priorityCode = val)
  return !opts.preventSync ? this.syncCanvas({ priorityCode }) : data
}

export function updateRecents(key) {
  const platformState = this.getRootState()
  const { appKey } = platformState
  const { recents } = platformState
  const recentExists = recents.indexOf(key)
  if (recentExists > -1) {
    this.call('removeFromArray', recents, recentExists)
  }
  if (key) {
    recents.unshift(key)
    if (appKey) {
      window.localStorage.setItem(
        `recents_${appKey}${platformState.branch}`,
        JSON.stringify(recents)
      )
    }
  }
}

export function activateFunction(val) {
  if (!this.call('isDefined', val)) {
    val = this
  }
  const data = this.getCanvasScope()
  const activeFunction = (data.activeFunction = val)
  if (activeFunction) {
    this.changeCodePriority('function')
  }
  return this.syncCanvas({ activeFunction })
}

export function activateState(val) {
  if (!this.call('isDefined', val)) {
    val = this
  }
  const data = this.getCanvasScope()
  const activeState = (data.activeState = val)
  if (activeState) {
    this.changeCodePriority('state')
  }
  return this.syncCanvas({ activeState })
}

export function activateDs(val) {
  if (!this.call('isDefined', val)) {
    val = this
  }
  const data = this.getCanvasScope()
  const activeDs = (data.activeDs = val)
  if (activeDs) {
    this.changeCodePriority('designSystem')
  }
  return this.syncCanvas({ activeDs })
}

export function getHovered() {
  return this.getCanvasScope('hovered')
}

export function getHoveredKey() {
  return this.getHovered()?.state?.key
}

export function getSelected() {
  return this.getCanvasScope('selected')
}

export function getSelectedKey() {
  return this.getSelected()?.state?.key
}

export function getChosen() {
  return this.getCanvasScope('chosen')
}

export function getChosenKey() {
  const chosen = this.getChosen()
  return this.call('isString', chosen) ? chosen : chosen?.state?.key
}

export function getInContext() {
  return this.getCanvasScope('inContext')
}

export function getInContextKey() {
  return this.getInContext()?.state?.key
}

export function getCanvasPositions() {
  return this.getCanvasScope('positions') || {}
}

export function zoomToNode(zoomedElement, opts = {}) {
  const canvasScope = this.getCanvasScope()
  const frameWindow = this.getCanvasFrameWindow()
  const { innerWidth, innerHeight } = frameWindow
  if (!canvasScope.panzoomInstance || !zoomedElement) {
    return
  }
  const getTransform = canvasScope.panzoomInstance.getTransform()

  if (opts.useZoom) {
    canvasScope.panzoomInstance.zoomAbs(getTransform.x, getTransform.y, 0.65)
  }

  setTimeout(() => {
    const zoomedNode = zoomedElement.node
    const { x, y, width, height } = zoomedNode.getBoundingClientRect()
    const panToX = x - (innerWidth - width) / 2
    const panToY = y - (innerHeight - height) / 2
    canvasScope.panzoomInstance.moveBy(-panToX, -panToY, true)
  }, 50)
}

// keep in methods, its needed in frame
export async function updateGridsInSchema(items) {
  const changes = items
    .map((item) => {
      if (!item.el?.ref) {
        console.error('[updateGridsInSchema] Missing element reference', item)
        return null
      }
      const { state } = item.el.ref
      if (!state || state.package) {
        return null // skip packaged components or invalid state
      }
      const type = this.getType(state)
      const path = ['schema', type, state.key, 'settings', 'gridOptions']
      const value = item._orig
      // Skip if value did not actually change – avoids unnecessary state churn
      const currentVal = state.settings?.gridOptions
      const isSame =
        currentVal && JSON.stringify(currentVal) === JSON.stringify(value)
      if (isSame) {
        return null
      }
      if (!state.settings) state.settings = {}
      state.settings.gridOptions = value
      return ['update', path, value]
    })
    .filter(Boolean)
  if (!changes.length) {
    return // nothing to apply
  }
  // Apply changes via CollabService but prevent a reactive run-through that would
  // immediately trigger another re-render, causing an infinite loop.
  // When the server eventually confirms (via commit) Canvas will still receive
  // the version update.
  try {
    this.sdk.updateData(changes, {
      skipCanvasUpdate: true,
      skipRuntimeTests: true,
      message:
        'Updated gridOptions on artboards at ' + this.getActiveCanvasPage()
    })
  } catch (e) {
    // If the collab connection is not yet established we fall back to applying
    // the changes locally so that the UI stays in sync.
    if (this.sdk?.getService) {
      const collab = this.sdk.getService('collab')
      collab?._stateManager?.applyChanges(changes, { preventUpdate: true })
    }
  }
}

export function getCleanCanvasScope(data) {
  const obj = {}
  const allowedKeys = [
    'explorer',
    'editorPanels',
    'docs',
    'previewSize',
    'modal',
    'followingUser',
    'openUrl',
    'editorActive',
    'activeCanvasPage',
    'hoverLayer',
    'activeLayer',
    'positions',
    'chosenPos',
    'monaco',
    'monacoSelection',
    'preferredEditor',
    'editorActive',
    'priorityCode',
    'showLayersSchema'
  ]
  const elementToUpdate = this.getWindowKeys()
  const allowedNodes = ['hovered', 'selected', 'chosen', 'inContext']
  for (const prop in data) {
    const val = data[prop]
    const allowed = allowedKeys.includes(prop) || elementToUpdate.includes(prop)
    if (allowed) {
      obj[prop] = val
    }
    if (allowedNodes.includes(prop)) {
      obj[prop] = this.call('isString', val)
        ? val
        : val?.state?.key
          ? val?.state?.key
          : null
    }
  }
  return obj
}

export function syncSocketCanvasData(clientData, opts = {}) {
  const platformState = this.getRootState()
  const canvasData = this.getCanvasScope()
  if (!canvasData) {
    return
  }

  const { userId, settings, followingUser } = platformState
  if (!settings.syncCanvas) {
    return
  }

  if (!followingUser || opts.forceSendSocket) {
    if (this.sdk?.isConnected()) {
      this.sdk.sendCursor({
        [userId]: {
          ...clientData
        }
      })
    }
  } else if (clientData.positions?.mouseX || clientData.chosenPos?.mouseX) {
    if (this.sdk?.isConnected()) {
      this.sdk.sendCursor({
        [userId]: {
          positions: clientData.positions?.mouseX && {
            mouseX: clientData.positions.mouseX,
            mouseY: clientData.positions.mouseY
          },
          chosenPos: clientData.chosenPos?.mouseX && {
            mouseX: clientData.chosenPos.mouseX,
            mouseY: clientData.chosenPos.mouseY
          }
        }
      })
    }
  }

  return clientData
}

export function syncCanvas(data = {}, opts = {}) {
  const platformState = this.getRootState()
  const canvasData = this.getCanvasScope()
  const { userId } = platformState

  const resetObjs = (key) => {
    if (data[key]) {
      data[key] = { ...canvasData[key], ...data[key] }
    }
  }

  resetObjs('positions')
  resetObjs('chosenPos')
  resetObjs('monaco')
  resetObjs('monacoSelection')

  // Merge incoming changes into current canvasData
  this.call('overwrite', canvasData, data)

  // Persist cleaned client state to rootState.clients
  if (!platformState.clients) platformState.clients = {}
  const reservedClientKeys = ['localhost', 'cli', 'platform']
  let clientKey = userId
  if (reservedClientKeys.includes(clientKey)) {
    clientKey = `user_${clientKey}`
  }
  const cleanData = (platformState.clients[clientKey] =
    this.getCleanCanvasScope(canvasData))

  // Store to localStorage when relevant ( skip continuous mouse move spam )
  const localStorageKey = `${this.getAppKey()?.split('.')[0]}__data`
  const changesWithValues = Object.values(cleanData).filter((v) => v).length
  if (!data.positions && changesWithValues) {
    this.call('setLocalStorage', localStorageKey, cleanData)
  }

  // Forward minimal delta via socket
  return this.call('syncSocketCanvasData', this.getCleanCanvasScope(data), opts)
}

export function syncCanvasPositions(positions) {
  const data = this.getCanvasScope()
  if (!data) {
    return
  }
  return this.syncCanvas({ positions })
}

// eslint-disable-next-line no-unused-vars
export function canvasFade(condition) {
  const { Fade } = this.getCanvas()
  if (condition) {
    Fade.fadeIn.background = `var(--theme-modalFade-${this.getRootState('globalTheme')}-backgroundColor)`
    Fade.setNodeStyles(Fade.fadeIn)
  } else {
    Fade.setNodeStyles(Fade.fadeOut)
  }
}

export function toggleLoading() {
  const data = this.getCanvasScope()
  if (!data) return
  // eslint-disable-next-line no-unused-vars
  this.variables({ loading: data?.loading }).changed((_) => {
    if (data.loading) {
      this.parent.LoadingGifSection?.setNodeStyles?.(
        this.parent.LoadingGifSection?.fadeIn
      )
    } else {
      this.parent.LoadingGifSection?.setNodeStyles?.(
        this.parent.LoadingGifSection?.fadeOut
      )
    }
  })
}

export const resetCanvasPan = function resetCanvasPan() {
  const canvasScope = this.getCanvasScope()
  const activeCanvasPage = this.getActiveCanvasPage()
  const localStorageKey = `${this.getAppKey()?.split('.')[0]}___${activeCanvasPage}`
  const fromStorage = JSON.parse(
    (this.call('sameOriginTop')?.localStorage || window.localStorage).getItem(localStorageKey)
  )
  const { x, y, scale } = fromStorage || this.getCanvasPositions() || {}
  const { panzoomInstance } = canvasScope
  if (panzoomInstance) {
    panzoomInstance.moveTo(x || 0, y || 0, scale || 1)
    panzoomInstance.zoomAbs(x || 0, y || 0, scale || 1)
  }
}

export function getCanvasScopeFromStorageOrData() {
  const localStorageData = this.getLocalStorageCanvasData()
  const platformState = this.getRootState()
  const { userId } = platformState

  return localStorageData || platformState.clients?.[userId]
}

// export function resetCanvasFromStorage() {
//   const initData = this.getCanvasScopeFromStorageOrData()
//   if (!initData) return

//   let data = initData
//   if (!this.getUserSettings('allowInitialSelection')) {
//     const { selected, chosen, ...rest } = initData
//     data = rest
//   }
//   if (this.getRootState('selected'))
//     data.selected = this.getRootState('selected')
//   this.call('overwrite', this.getCanvasScope(), data)
// }

export function isDashboard() {
  const { pathname } = window.location
  if (pathname.startsWith('/dashboard')) return true
}

export function isAuthorised() {
  return Boolean(this.sdk?.getAuthToken())
}

export function isFree() {
  return Boolean(this.getRootState('tier') === 'free')
}

export function isCanvas(routeOverride) {
  const pathname = routeOverride || window.location.pathname
  if (pathname.startsWith('/canvas') || pathname.startsWith('/embed'))
    return true

  const [, user, project] = pathname.split('/')

  if (!user || !project || this.getCanvasPathname() !== `/${user}/${project}`) {
    return
  }

  return Boolean(this.getCanvasScope())
}

export function isEmbed() {
  return this.getRootState('isEmbed')
}

export function isEditMode() {
  return !this.isEmbed() && this.sdk?.hasPermission('editMode')
}

export function isAdmin() {
  return ['owner', 'admin'].includes(this.getRootState('projectRole'))
}

export function isOwner() {
  return ['owner'].includes(this.getRootState('projectRole'))
}

export function isReadOnly() {
  return !this.isEditMode()
}

export function preventLocationChanges(window) {
  // Intercept beforeunload/navigation attempts
  // window.addEventListener('beforeunload', (e) => {
  //   e.preventDefault()
  // })
  // const expectedUrl = this.getCanvasPathnameAnyway()
  // new MutationObserver(() => {
  //   if (window.location.href !== expectedUrl) {
  //     console.warn('Blocked forced navigation')
  //     window.location.replace(expectedUrl)
  //   }
  // }).observe(document, { childList: true, subtree: true })
}

export function isDocs() {
  const { pathname } = window.location
  if (
    ['/docs', '/tutorials', '/index'].some(
      (p) => pathname === p || pathname.startsWith(`${p}/`)
    )
  )
    return true
}

export function isDevelopers() {
  const { pathname } = window.location
  if (
    ['/developers'].some((p) => pathname === p || pathname.startsWith(`${p}/`))
  )
    return true
}

export function getCanvasPathname() {
  const { workingProjectOwner, workingProjectKey } = this.getRootState() || {}
  if (!workingProjectOwner || !workingProjectKey) return
  return `/${workingProjectOwner}/${workingProjectKey}`
}

export function getCanvasPathnameAnyway() {
  if (this.getCanvasPathname()) return this.getCanvasPathname()
  let { appKey, owner } = this.getRootState() || {}
  appKey = appKey?.split('.')[0]
  owner = owner?.username
  if (!owner) {
    const { members } = this.getRootState() || {}
    owner = members?.find((m) => m.role === 'owner')?.username
  }
  return appKey && owner ? `/${owner}/${appKey}` : '/dashboard'
}

export function getCanvasPathnameLocal() {
  const s = this.state
  return `/${s.owner?.username}/${s.key.split('.')[0]}`
}

export function addOnCanvasStr(codeStr, type = 'functions') {
  const Canvas = this.getCanvas()
  const Collection = this.getCanvasCollection()
  if (Collection) {
    const { contentWindow } = Canvas.Iframe.node
    const evalCode = this.call('evalStringCodeUnsafe', codeStr, {
      secrets: this.getSecrets(),
      window: contentWindow
    })
    const ctx = Collection.context
    ctx[type][key] = evalCode
    ctx.utils[key] = evalCode
    const { packages } = contentWindow
    packages[type][key] = evalCode
    packages.utils[key] = evalCode
  } else {
    this.error('Canvas Collection was not found')
  }
}

export function openArtboardItem(type = 'components', key) {
  if (!this.call('inOnCurrentCanvasPage', type, key)) {
    this.call(
      'openCanvasPage',
      this.call('findKeyInOtherCanvasPages', key) || 'Default'
    )
  }
  const t = window.setTimeout(() => {
    this.activateSelected(key)
    const data = this.getCanvasScope()
    const t2 = window.setTimeout(() => {
      this.zoomToNode(data.selected)
      clearTimeout(t2)
    }, 100)
    clearTimeout(t)
  }, 35)
}

export function openItem(type = 'components', key) {
  if (this.call('hasType', 'ARTBOARD_TYPES', type)) {
    return this.call('openArtboardItem', type, key)
  }
  if (this.call('hasType', 'FUNCTION_TYPES', type)) {
    return this.activateFunction(key)
  }
  if (this.call('hasType', 'STATE_TYPES', type)) {
    return this.activateState(key)
  }
  if (this.call('hasType', 'ASSETS_TYPES', type)) {
    return this.call('openModal', '/edit-file', {
      key: key
    })
  }
}

export function getCanvasMode() {
  return this.getCanvasScope('canvasMode')
}

export function isCanvasMode(mode) {
  const canvasMode = this.getCanvasScope('canvasMode')
  if (mode === 'defaultMode') return !canvasMode || canvasMode === 'defaultMode'
  return canvasMode === mode
}

export function setCanvasMode(mode) {
  return (this.getCanvasScope().canvasMode = mode)
}
